import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	CPMFilesUploadRequest
} from '../requests/CPMFilesUploadRequests.js';

export const CPM_ENABLING_CHECKS = 'CPM_ENABLING_CHECKS';

export const UploadCPMFiles = (filePath, userName, userId) => async (dispatch) => {
	await CPMFilesUploadRequest(filePath, userName, userId).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunFileUpload = (file, userName, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(UploadCPMFiles(response.data, userName, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
